import { IButton } from 'interfaces/i-buttons';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { ReactNode } from 'react';

export interface IBaseDialog {
  identifier: string;

  // shown on the right side of the footer
  buttons?: IButton[];

  leftFooter?: ReactNode;

  onClose: () => void;

  /** whether the global context should count this for tracking what's open */
  ignore?: boolean;
}

export interface IFullDialog extends IBaseDialog {
  width: string;
  maxWidth?: string;
  // if not provided, the container will hug content, else it will support vertical flexing
  vFlexHeight?: string;

  // if true, clicking on the overlay won't close the dialog
  modal?: boolean;

  // shows an indicator that something is loading
  loading?: boolean;

  title?: ReactNode;

  // e.g. render a button next to close button at the top of the dialog
  titleActions?: ReactNode;

  subtitle?: ReactNode;

  // e.g. text above a form describing what the form is for
  description?: string;

  content: ReactNode;

  onOpenChange?: (open: boolean) => void;
}

export const DEFAULT_ACCEPT_BTN: IButton = {
  label: 'common.accept',
  color: RADIX.COLOR.ACCENT,
  variant: 'solid',
};
